var $f28bbea439e87eca$exports = {};
$f28bbea439e87eca$exports = {
    "breadcrumbs": `Breadcrumbs`
};


export {$f28bbea439e87eca$exports as default};
//# sourceMappingURL=de-DE.module.js.map
